import "./mention-card.scss";
import CurrencyFormat from "react-currency-format";
import { RootState } from "types";
import { useSelector } from "react-redux";

function MentionCard({ loading, streamId, clipCount, ave, onClick }: { loading: boolean; streamId: number; clipCount: number; ave: number; onClick: () => void }) {
    const core = useSelector((state: RootState) => state.core);
    const stream = core.Stream.find((x) => x.Id === streamId);
    const getStreamName = () => {
        return (
            {
                7: "x-twitter",
                8: "facebook",
                9: "instagram",
                10: "youtube",
                11: "linkedin",
                12: "tiktok",
            }[streamId] || ""
        );
    };
    // const stream = useStream(streamId);

    const handleOnClick = (e: any) => {
        e.stopPropagation();
        onClick();
    };

    return (
        <div className={`mention-card stream-id-${streamId}`} onClick={handleOnClick}>
            {streamId !== 0 ? <i className={`fab fa-${getStreamName()}`}></i> : <i className={`fal fa-globe`}></i>}
            <p className="clip-count">{loading ? <i className="fal fa-spinner fa-spin"></i> : clipCount}</p>
            <p className="ave">{loading ? <i className="fal fa-spinner fa-spin"></i> : <CurrencyFormat value={ave.toFixed(2)} prefix="R" displayType="text" thousandSeparator={true} />}</p>
        </div>
    );
}

export default MentionCard;
